module.exports = __webpack_public_path__ + "media/images/front/icon_bell_active-8b4ce0149489cdc8b25c967eb1421a17.png";